import Enemy from "../enemy/Enemy";
import EnemyType from "../../enums/EnemyType";

export interface FormationConfig {
  enemyType: EnemyType;
  enemyCount: number;
  radius: number;
  rotationSpeed: number;
  spawnDistance?: number;
  showPointerAfterMinute?: number;
}

export default abstract class BaseFormation {
  protected scene: Phaser.Scene;
  protected enemies: Enemy[] = [];
  protected centerX: number;
  protected centerY: number;
  protected config: FormationConfig;
  protected angleStep: number = 0;

  constructor(
    scene: Phaser.Scene,
    x: number,
    y: number,
    config: FormationConfig
  ) {
    this.scene = scene;
    this.centerX = x;
    this.centerY = y;
    this.config = config;
    this.createFormation();
  }

  protected abstract createFormation(): void;

  public update(): void {
    this.updateFormation();
  }

  protected updateFormation(): void {
    this.angleStep -= this.config.rotationSpeed;

    this.enemies.forEach((enemy, index) => {
      if (!enemy.isDead) {
        const baseAngle = (index * Math.PI * 2) / this.enemies.length;
        const currentAngle = baseAngle + this.angleStep;

        const newX = this.centerX + Math.cos(currentAngle) * this.config.radius;
        const newY = this.centerY + Math.sin(currentAngle) * this.config.radius;

        enemy.setPosition(newX, newY);
        enemy.setVelocity(0, 0);
        enemy.setFlipX(Math.cos(currentAngle) > 0);
      }
    });
  }

  public destroy(): void {
    this.enemies.forEach((enemy) => {
      if (!enemy.isDead) {
        enemy.setInFormation(false);
      }
    });

    this.enemies = [];
  }

  public isActive(): boolean {
    return this.enemies.some((enemy) => !enemy.isDead);
  }

  public get x(): number {
    return this.centerX;
  }

  public get y(): number {
    return this.centerY;
  }

  public getConfig(): FormationConfig {
    return this.config;
  }
}
